
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.616 24H5.384A2.38 2.38 0 013 21.628V7.152a.5.5 0 011 0v14.476A1.38 1.38 0 005.384 23h13.232A1.38 1.38 0 0020 21.628V7.152a.5.5 0 011 0v14.476A2.38 2.38 0 0118.616 24z"}}),_c('path',{attrs:{"d":"M15.5 20h-7a.5.5 0 010-1h7a.5.5 0 010 1zm8-10a.505.505 0 01-.309-.106L12 1.135.809 9.894a.5.5 0 01-.618-.788l11.5-9a.5.5 0 01.618 0l11.5 9A.5.5 0 0123.5 10z"}})])
          )
        }
      }
    